<template>
	<b-container class="mt-5" fluid="lg">
		<b-row>

			<b-col md="6">

				<h2>Create Project</h2>
				<validation-observer ref="observer" v-slot="{ handleSubmit }">
					<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">

						<validation-provider v-slot="validationContext" name="Project Name" v-bind:rules="{ required: true }" vid="name">
							<b-form-group ref="project-name" label="Name" label-for="project-name">
								<b-form-input id="project-name" v-model="project.name" v-bind:state="getValidationState( validationContext )"></b-form-input>
								<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
							</b-form-group>
						</validation-provider>

						<validation-provider v-slot="validationContext" name="Customer" v-bind:rules="{ required: true }" vid="customer">
							<b-form-group ref="project-client" label="Client" label-for="project-client">
								<autocomplete id="project-client" v-model="project.customer" endpoint="/customers/search/{token}" label-key="name" v-bind:validation-context="validationContext"></autocomplete>
							</b-form-group>
						</validation-provider>

						<b-form-row>
							<b-col md="6">

								<b-form-group ref="project-start-date" label="Start" label-for="project-start-date">
									<b-form-datepicker id="project-start-date" v-model="project.start_date" v-bind:date-format-options="date_picker_options"></b-form-datepicker>
								</b-form-group>

							</b-col>
							<b-col md="6">

								<b-form-group ref="project-end-date" label="End" label-for="project-end-date">
									<b-form-datepicker id="project-end-date" v-model="project.end_date" v-bind:date-format-options="date_picker_options"></b-form-datepicker>
								</b-form-group>

							</b-col>
						</b-form-row>

						<b-button block type="submit">
							<b-icon v-show="loading" animation="spin" aria-hidden="true" class="mr-2" icon="gear-fill"></b-icon>
							Create Project
						</b-button>

					</b-form>
				</validation-observer>

			</b-col>
		</b-row>
	</b-container>
</template>

<style lang="scss">
@import "src/assets/variables";

.project-tile {
	min-width: 100%;
	max-width: 100%;

	+ .project-tile {
		margin-top: 1em;
	}
}
</style>

<script>
import Autocomplete from '../components/Autocomplete'
// import ProjectTile from '../components/ProjectTile'

export default {
	name: 'Create',

	components: {
		Autocomplete,
		// ProjectTile
	},

	computed: {
		recent () {
			return this.projects.slice().sort((a, b) => ( new Date(b.last_accessed) ) - ( new Date(a.last_accessed) )).slice(0, 3)
		}
	},

	data () {
		return {
			temp: {
				id: 23,
				name: 'Project Name Here',
				customer: { name: '' },
				start_date: '2020-08-13',
				end_date: '2020-11-30',
				number_products: 485395,
				number_prizes: 1855
			},

			loading: false,

			project: {
				name: '',
				customer: null,
				start_date: null,
				end_date: null
			},

			date_picker_options: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			},

			filter: '',
			projects: []
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			this.loading = !this.loading
			this.$refs['observer'].reset()

			this.$axios.post('/projects', this.project)
				.then(response => {
					this.project.name = ''
					this.project.client = {}
					this.project.start_date = null
					this.project.end_date = null
					this.loading = !this.loading

					this.$axios.post('/projects/access', { id: response.data.id })

					this.$router.push(`/projects/${response.data.id}/details`)
				})
				.catch(() => {
					this.loading = !this.loading
				})

		}
	},

	mounted () {
		this.$axios.get('/projects')
			.then(response => {
				this.projects = response.data
			})
	}
}
</script>
